import qs from 'qs';
import { axiosApi } from '../axios';

const DEVELOPERS_URL = 'developers';
const FEATURES_URL = 'features';
const FILTERS_URL = 'filters';
const FAVORITES_URL = 'favorite_developers';
const PROJECTS_URL = 'projects';
const RECRUITMENTS_URL = 'recruitments';
const CANDIDATES_URL = 'candidates';
const REPORTS_URL = 'reports';
const ISSUES_URL = 'issues';
const ATTACHMENT_URL = 'attachments';

export default {
  developers: {
    index(filterParams) {
      return axiosApi.get(`/hr/${DEVELOPERS_URL}`, {
        params: filterParams,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
      });
    },

    show(id) {
      return axiosApi.get(`/hr/${DEVELOPERS_URL}/${id}`);
    },

    create(data) {
      return axiosApi.post(`/hr/${DEVELOPERS_URL}/`, data);
    },

    update(id, data) {
      return axiosApi.put(`/hr/${DEVELOPERS_URL}/${id}`, data);
    },

    delete(id) {
      return axiosApi.delete(`/hr/${DEVELOPERS_URL}/${id}`);
    },

    invite(data) {
      return axiosApi.post(`/hr/${DEVELOPERS_URL}/invite`, data);
    },

    inviteExisting(id) {
      return axiosApi.patch(`/hr/${DEVELOPERS_URL}/${id}/invite`);
    },

    survey(id) {
      return axiosApi.get(`/hr/${DEVELOPERS_URL}/${id}/survey_answers`);
    },
  },

  filters: {
    index() {
      return axiosApi.get(`/hr/${FILTERS_URL}`);
    },
  },

  features: {
    index() {
      return axiosApi.get(`${FEATURES_URL}`);
    },
  },

  favorites: {
    index(filterParams) {
      return axiosApi.get(`/hr/${FAVORITES_URL}`, {
        params: filterParams,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
      });
    },

    add(id) {
      return axiosApi.post(`/hr/${FAVORITES_URL}`, { developer_id: id });
    },

    delete(id) {
      return axiosApi.delete(`/hr/${FAVORITES_URL}/${id}`);
    },
  },

  projects: {
    index(paginationParams) {
      return axiosApi.get(`/hr/${PROJECTS_URL}`, {
        params: paginationParams,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
      });
    },

    show(id) {
      return axiosApi.get(`/hr/${PROJECTS_URL}/${id}`);
    },

    update(id, data) {
      return axiosApi.put(`/hr/${PROJECTS_URL}/${id}`, data);
    },

    create(data) {
      return axiosApi.post(`/hr/${PROJECTS_URL}`, data);
    },

    delete(id) {
      return axiosApi.delete(`/hr/${PROJECTS_URL}/${id}`);
    },

    recentSummary(projectId) {
      return axiosApi.get(`/hr/${PROJECTS_URL}/${projectId}/reports/recent_summary`);
    },

    getReport(projectId, data) {
      return axiosApi.get(`/hr/${PROJECTS_URL}/${projectId}/reports`, { params: data });
    },

    updateReport(reportId, date) {
      return axiosApi.patch(`/hr/${REPORTS_URL}/${reportId}`, date);
    },
  },

  recruitments: {
    show(id) {
      return axiosApi.get(`/hr/${RECRUITMENTS_URL}/${id}`);
    },

    create(projectId, data) {
      return axiosApi.post(`/hr/${PROJECTS_URL}/${projectId}/${RECRUITMENTS_URL}`, data);
    },

    update(recruitmentId, data) {
      return axiosApi.put(`/hr/${RECRUITMENTS_URL}/${recruitmentId}`, data);
    },

    updateStatus(recruitmentId, data) {
      return axiosApi.put(`/hr/${RECRUITMENTS_URL}/${recruitmentId}/status`, data);
    },

    score(recruitmentId, developerId) {
      return axiosApi.get(`/hr/${RECRUITMENTS_URL}/${recruitmentId}/developers/${developerId}/score`);
    },

    delete(recruitmentId) {
      return axiosApi.delete(`/hr/${RECRUITMENTS_URL}/${recruitmentId}`);
    },
  },

  candidates: {
    index(id, filterParams) {
      return axiosApi.get(`/hr/${RECRUITMENTS_URL}/${id}/candidates`, {
        params: filterParams,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
      });
    },

    create(candidate) {
      return axiosApi.post(`/hr/${CANDIDATES_URL}/`, candidate);
    },

    delete(candidateData) {
      return axiosApi.delete(`/hr/${CANDIDATES_URL}/`, { data: candidateData });
    },

    offer(candidatesIds) {
      return axiosApi.patch(`/hr/${CANDIDATES_URL}/bulk_offer`, candidatesIds);
    },

    updatedStatus(candidatesId, status) {
      return axiosApi.put(`/hr/${CANDIDATES_URL}/${candidatesId}/`, { status });
    },
  },

  contracts: {
    create(projectId, data) {
      return axiosApi.post(`/hr/${PROJECTS_URL}/${projectId}/contracts`, data);
    },

    update(projectId, contractId, data) {
      return axiosApi.put(`/hr/${PROJECTS_URL}/${projectId}/contracts/${contractId}`, data);
    },

    delete(projectId, contractId) {
      return axiosApi.delete(`/hr/${PROJECTS_URL}/${projectId}/contracts/${contractId}`);
    },
  },

  attachments: {
    create(data) {
      return axiosApi.post(`/hr/${ATTACHMENT_URL}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },

    update(attachmentId, clientVisibility) {
      return axiosApi.patch(`/hr/${ATTACHMENT_URL}/${attachmentId}`, { client_visibility: clientVisibility });
    },

    delete(id) {
      return axiosApi.delete(`/hr/${ATTACHMENT_URL}/${id}`);
    },
  },

  cv: {
    show(developerId, cvParams) {
      return axiosApi.post(`/hr/${DEVELOPERS_URL}/${developerId}/cv`, cvParams, { responseType: 'blob' });
    },
  },

  issues: {
    index(paginationParams) {
      return axiosApi.get(`/hr/${ISSUES_URL}`, {
        params: paginationParams,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
      });
    },

    show(id) {
      return axiosApi.get(`/hr/${ISSUES_URL}/${id}`);
    },

    complete(id) {
      return axiosApi.patch(`/hr/${ISSUES_URL}/${id}/complete`);
    },

    reply(id, message) {
      return axiosApi.post(`/hr/${ISSUES_URL}/${id}/issue_messages`, { content: message });
    },
  },
};
